import { NavigateFunction, useNavigate } from 'react-router-dom'

import Screens from './Screens'

export const enhanceNavigator = (navigate: NavigateFunction): Navigation => {
  return {
    push: (name: string, params?: { [key: string]: any }) => {
      const s = Screens[name]
      if (s) {
        navigate(s.path, { state: params })
      }
    },
    pushPath: navigate,
    goBack: () => navigate(-1),
    navigate: (name: string, params?: { [key: string]: any }) => {
      const s = Screens[name]
      if (s) {
        navigate(s.path, { state: params })
      }
    },
    openDrawer: () => null,
  }
}

const useNav = () => {
  const nav = useNavigate()
  return enhanceNavigator(nav)
}

export default useNav
